import { REDUX_ROOT_GUI, REDUX_ROOT_GUI_LOGIN_SCREEN } from "../store";

export function loginScreenSelector(state = {}) {
	return state[REDUX_ROOT_GUI][REDUX_ROOT_GUI_LOGIN_SCREEN];
}
